import { inject, InjectionToken } from '@angular/core';
import { userPreferencesStore } from '@app/signal-store/user-preferences/user-preferences.store';

/**
 * Pairs a Customer.io in-app message `actionValue` with the side effect to run
 * when a user takes that action.
 */
export interface InAppMessageActionHandler {
  actionValue: string;
  handle: () => void;
}

/**
 * DI token listing the in-app message actions we react to.
 *
 * Add an entry per `actionValue` you configure in the Customer.io composer.
 * When a message action with the matching value arrives,
 * `InAppMessageActionService` runs its `handle`. The factory runs in the root
 * injection context, so handlers can close over injected dependencies.
 *
 * Override this token in tests to exercise the service with a fixed set.
 */
export const IN_APP_MESSAGE_ACTIONS = new InjectionToken<readonly InAppMessageActionHandler[]>(
  'IN_APP_MESSAGE_ACTIONS',
  {
    providedIn: 'root',
    factory: () => {
      const userPreferences = inject(userPreferencesStore);

      return [
        {
          actionValue: 'EnableLabs',
          // Turn Labs on for the user without opening the Labs dialog — the
          // dialog only opens via the `labs-open` query param (see
          // LabsDeepLinkService). The store shows the confirmation toast.
          handle: () => userPreferences.setLabsEnabled(true),
        },
      ];
    },
  },
);
